import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { Companies } from '@/features/companies'

const companiesSearchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(50),
  filter: z.string().optional().catch(''),
  industries: z.array(z.string()).optional().catch([]),
  countries: z.array(z.string()).optional().catch([]),
  revenueBuckets: z.array(z.string()).optional().catch([]),
  businessTypes: z.array(z.string()).optional().catch([]),
  latkaIndustries: z.array(z.string()).optional().catch([]),
  employeeCount: z.string().optional(),
  qualityScore: z.string().optional(),
  totalFunding: z.string().optional(),
  enrichmentStatus: z.enum(['all', 'enriched', 'unenriched']).optional().catch(undefined),
  sources: z.array(z.enum(['apollo', 'lemlist', 'extruct'])).optional().catch([]),
  authorityTiers: z.array(z.string()).optional().catch([]),
  sizes: z.array(z.string()).optional().catch([]),
  fundingStages: z.array(z.string()).optional().catch([]),
  tags: z.array(z.string()).optional().catch([]),
  tagsMode: z.enum(['any', 'all']).optional().catch('any'),
  view: z.enum(['table', 'grid']).optional().catch('table'),
  companyId: z.string().optional(),
  sortColumn: z.string().optional(),
  sortDir: z.enum(['asc', 'desc']).optional(),
})

export type CompaniesSearchParams = z.infer<typeof companiesSearchSchema>

export const Route = createFileRoute('/_authenticated/companies/')({
  validateSearch: companiesSearchSchema,
  component: Companies,
})
